import React, { useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { FlexboxGrid, Panel, Row } from 'rsuite'
import pathname from '../../constants/pathname'
import AppContext from '../../context/AppContext'
import ErrorWidget from '../../widgets/errorWidget/ErrorWidget'
import PanalLoadingTemplate from '../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import {
  getSubProjectMain,
  searchSubProjectMain,
  getListInSubProject,
  searchListInSubProject,
  getSubProjectCounterSummary,
} from '../../redux/actions/dashboard'
import './styles.less'
import { startLoading, doneLoading } from '../../utils/loading'
// import TableSubProject from '../../widgets/dashboard/SubProject'
import TableSubProject from '../../widgets/tableSubProject/TableSubProject'
import TableSubProjectList from '../../widgets/tableSubProject/TableSubProjectList'
import { useForm, Controller } from 'react-hook-form'
import SidebarProposal from '../../layouts/sidebarProposal/SidebarProposal'
import Profile from '../../widgets/dashboard/Profile'
import { useCookies } from 'react-cookie'
//import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'
import UpDownStreamWidget from '../../widgets/dashboard/UpDownStreamWidget'
import StatusWidget from '../../widgets/dashboard/StatusWidget'
import {
  PROJECTID_FOR_SUB,
  SUB_FOLLOW_ID,
  SUB_PROJECT_CODE,
  SUB_PROJECT_ID,
} from '../../constants/constants'
import { DEFAULT_ERR_MSG } from '../../constants/msgText'
import notification from '../../utils/notification'
import { setAlertMessage } from '../../utils/messageUtil'

export default function SubProject() {
  const contextValue = React.useContext(AppContext)

  const history = useHistory()
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()
  const [loading, setloading] = useState(false)
  const { register, handleSubmit, errors, control, setValue, clearErrors } = useForm()
  const [showListTb, setShowListTb] = useState(false)
  const [schemaListTb, setSchemaListTb] = useState()
  const [showSubTb, setShowSubTb] = useState(true)

  const [projectId, setProjectId] = useState('')
  const [totalBudget, setTotalBudget] = useState(0)
  const [tempSchema, setTempSchema] = useState()
  const [summarySchema, setSummarySchema] = useState()

  const [cookies, setCookie, removeCookie] = useCookies(['projectforsub_cookie'])

  useEffect(() => {
    sessionStorage.removeItem('temp_id')
    sessionStorage.removeItem(SUB_PROJECT_ID)
    sessionStorage.removeItem(SUB_PROJECT_CODE)
    sessionStorage.removeItem(SUB_FOLLOW_ID)

    handelGetSchemaDashboardMain()
    handelGetNewCounterDashboard()
  }, [])

  const handelGetSchemaDashboardMain = async (pagesize, pagenumber) => {
    setIsLoading(true)
    try {
      const response = await getSubProjectMain(pagesize || 5, pagenumber || 1)
      // console.log('response ', response.values)
      setSchema(response)
      setDefaultPage(response.values)
    } catch (e) {
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    setIsLoading(false)
  }

  const setDefaultPage = (values) => {
    if (values) {
      const projectId = sessionStorage.getItem(PROJECTID_FOR_SUB)
      console.log('projectId => ', projectId)
      projectId && handleSelectProjectMain(projectId)
    }
  }

  const handleSearchProjectMain = async (pagesize, pagenumber, code, name, year) => {
    startLoading()
    setloading(true)
    try {
      const response = await searchSubProjectMain(pagesize, pagenumber, code, name, year)

      if (response) {
        setSchema(response)
      }
    } catch (e) {
      console.log('e', e)
    }
    setloading(false)
    doneLoading()
  }

  const onSingleSubmitMain = (obj) => {
    sessionStorage.setItem('projectId', obj.id)
    sessionStorage.setItem(SUB_PROJECT_ID, obj.id)
    sessionStorage.setItem('param', '')

    // history.push(`${pathname.proposal.overview.overviewCoworker}/${obj.id}`)
    history.push(`${pathname.proposal.overview.overviewCoworker}`)
  }

  const handleSelectProjectMain = async (pid, budget) => {
    try {
      const response = await getListInSubProject(5, 1, pid)

      if (response) {
        // pid != cookies.projectforsub_cookie && saveCookie(pid)
        sessionStorage.setItem(PROJECTID_FOR_SUB, pid)

        let totalBudget = response?.projectInfo?.totalBudget || 0
        // response.subProjectList.values.length > 0 &&
        //   response.subProjectList.values.map((item) => {
        //     totalBudget = totalBudget + item.projectBudget
        //   })

        setSchemaListTb(response)
        // setSchemaListTb(mock)
        setProjectId(pid)
        setTotalBudget(totalBudget)
        setShowListTb(true)
        setShowSubTb(true)
      }
    } catch (e) {
      console.log(e)
      setError({})
    }
  }

  const saveCookie = (mainProjectId) => {
    console.log('saveCookie', mainProjectId)
    let date = new Date()
    date.setTime(date.getTime() + 3 * 24 * 60 * 60 * 1000)

    // setCookie('projectforsub_cookie', mainProjectId, {
    //   path: `${pathname.subProject.subProjectDashboard}`,
    //   expires: date,
    // })
    setCookie('projectforsub_cookie', mainProjectId, { path: '/', expires: date })
  }

  const handleCancelSelectProject = (action) => {
    setShowListTb(false)
    setSchemaListTb({})
    setShowSubTb(false)
    sessionStorage.removeItem(PROJECTID_FOR_SUB)
    // console.log('remove cookie')
    // let date = new Date()
    // date.setTime(date.getTime() + 3 * 24 * 60 * 60 * 1000)
    // removeCookie('projectforsub_cookie', { path: '/', expires: date })
  }

  const handelGetSchemaDashboardList = async (pagesize, pagenumber) => {
    setIsLoading(true)
    try {
      const response = await getListInSubProject(pagesize || 5, pagenumber || 1)
      setSchema(response)
    } catch (e) {
      setError({})
    }
    setIsLoading(false)
  }

  const handleSearchProjectList = async (pagesize, pagenumber, code, name, status) => {
    startLoading()
    setloading(true)
    try {
      const response = await searchListInSubProject(
        pagesize,
        pagenumber,
        projectId,
        code,
        name,
        status
      )

      if (response) {
        setSchemaListTb(response)
      }
    } catch (e) {
      console.log('e', e)
    }
    setloading(false)
    doneLoading()
  }

  const handelGetNewCounterDashboard = async () => {
    setIsLoading(true)
    try {
      const response = await getSubProjectCounterSummary()

      setSummarySchema(response)
    } catch (e) {
      setAlertMessage('error', e?.response?.data?.errors?.Message || DEFAULT_ERR_MSG)
    }
    setIsLoading(false)
  }

  if (error) {
    return (
      <SidebarProposal isSubProjectReport>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal isSubProjectReport>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <>
      <SidebarProposal isSubProjectReport>
        <Profile />
        {summarySchema?.datas && (
          <>
            <Panel
              // header={'ติดตามสถานะ'}
              bordered
              collapsible
              shaded
              defaultExpanded
              style={{ marginTop: 20 }}
            >
              <FlexboxGrid style={{ marginTop: -10 }}>
                <StatusWidget
                  datas={summarySchema.datas || []}
                  showEnd={false}
                  showLine
                  dashBoardName={'coodinatorSummary'}
                  colSize={4}
                  url={pathname.subProjectNew.subProjectListSratusReport}
                />
              </FlexboxGrid>
            </Panel>
          </>
        )}

        <Panel
          header={schema?.titleHeader}
          bordered
          collapsible
          shaded
          defaultExpanded
          className="table-all-project"
          style={{ marginTop: 20 }}
        >
          {schema && !showListTb && (
            <TableSubProject
              schema={schema}
              single={{
                enable: true,
              }}
              onSingleSubmit={onSingleSubmitMain}
              Controller={Controller}
              control={control}
              pagination={true}
              onReload={handleSearchProjectMain}
              loading={loading}
              searchRows={{ enable: true }}
              onSearchProject={handleSearchProjectMain}
              onSelectProject={handleSelectProjectMain}
              onShow={showSubTb}
            />
          )}

          {showListTb && (
            <>
              <TableSubProjectList
                schema={schemaListTb}
                totalBudget={totalBudget}
                single={{
                  enable: true,
                }}
                ProjectId={projectId}
                onSingleSubmit={onSingleSubmitMain}
                Controller={Controller}
                control={control}
                pagination={true}
                onReload={handleSearchProjectList}
                loading={loading}
                searchRows={{ enable: true }}
                onSearchProject={handleSearchProjectList}
                onCancelSelectProject={handleCancelSelectProject}
                onSelectProject
              />
            </>
          )}
        </Panel>
        <br />
      </SidebarProposal>
    </>
  )
}
